export default class genericProject {
  constructor(tech, body, img, alt, desc, link) {
    this.tech = tech;
    this.body = body;
    this.img = img;
    this.alt = alt;
    this.desc = desc;
    this.link = link;
  }
}
